<template>
  <TabsBtn
    v-if="h2hHome.length > 0 || h2hAway.length > 0"
    :tabs="tabs"
    :activeTab="activeTab"
    @change="changeTab"
    :isShowBorder="true"
  />
  <NoData v-else />

  <div v-if="h2hHome.length > 0 || h2hAway.length > 0" class="as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup">
    <div v-show="activeTab !== 'away'">
      <H2hTab
        :h2h="h2hHome"
        :teams="h2h.teams"
        :competitions="h2h.competitions"
        :match="match"
        tab="home"
        :homeTeamId="match.home_team_id"
      />
      <NoData v-if="h2hHome.length === 0" />
    </div>
    <div v-show="activeTab !== 'home'">
      <H2hTab
        :h2h="h2hAway"
        :teams="h2h.teams"
        :competitions="h2h.competitions"
        :match="match"
        tab="away"
        :homeTeamId="match.away_team_id"
      />
      <NoData v-if="h2hAway.length === 0" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { IMatch, IH2h } from "~src/interfaces";
import H2hTab from "~src/components/h2h/basketball/H2hTab.vue";
import MatchEnum from "~src/enums/basketball/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";

interface IProps {
  match: IMatch;
  h2h: IH2h;
}

const props = withDefaults(defineProps<IProps>(), {});

const activeTab = ref("home");

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
}

const h2hHome = computed(() => {
  return props.h2h.future.home.filter((item: any) => {
    return (
      item[3] == MatchEnum.STATUS_NOT_STARTED &&
      (props.match.home_team?.id === item[6][0] ||
        props.match.home_team?.id === item[7][0])
    );
  });
});

const h2hAway = computed(() => {
  return props.h2h.future.away.filter((item: any) => {
    return (
      item[3] == MatchEnum.STATUS_NOT_STARTED &&
      (props.match.away_team?.id === item[6][0] ||
        props.match.away_team?.id === item[7][0])
    );
  });
});
</script>

<script lang="ts">
export default {};
</script>
